module.exports = __webpack_public_path__ + "img/cases-brand-avic-lazyload-325.df502580.jpg";